import {getFavouriteQuizList} from "../services/quizService";

/**
 * Get list of saved questions
 * @returns {function(*): *}
 */
export const getSavedQuizs = () => dispatch => {
    dispatch(request());
    // function to get all questions saved by user
    getFavouriteQuizList().then((quizList) => {
            // dispatching quiz list to reducer
        dispatch(success(quizList));
        })
        .catch((error) => {
            // handle error
            dispatch(failure(error.toString()));
        });

    function request() {
        return {type: 'SAVED_QUIZ_REQUEST'}
    }

    function success(quizList) {
        return {type: 'SAVED_QUIZ_SUCCESS', quizList}
    }

    function failure(error) {
        return {type: 'SAVED_QUIZ_FAILURE', error}
    }

};